import { render, staticRenderFns } from "./LinkedRevenueItem.vue?vue&type=template&id=62f31c4b&scoped=true&"
import script from "./LinkedRevenueItem.vue?vue&type=script&lang=js&"
export * from "./LinkedRevenueItem.vue?vue&type=script&lang=js&"
import style0 from "./LinkedRevenueItem.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./LinkedRevenueItem.vue?vue&type=style&index=1&id=62f31c4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f31c4b",
  null
  
)

export default component.exports